import { CategoryStateInterface } from '.';

function state(): CategoryStateInterface {
  return {
    categories: [],
  };
}

export default state;
